<script>
  import { _ } from 'svelte-i18n'
  import { buy_modal_initiator, user, user_subscription, user_valid } from '../stores'
  import { getFeatureName } from '../modules/helpers'

  $: feature_name = getFeatureName($buy_modal_initiator)
</script>
<h2>
  {#if $user && !$user_valid}
    <b><span class="accent">{$_('modals.features.expired')}</span></b>
    {#if $user_subscription}
      {$_('modals.features.renewSubscription')} {$_('modals.features.toUnlock')}
    {:else}
      {$_('modals.features.subscribe')} {$_('modals.features.toUnlock')}
    {/if}
  {:else}
    {#if $buy_modal_initiator === 'ads'}
      <b>Remove advertisements</b> and unlock all the time saving features
    {:else if $buy_modal_initiator === 'support'}
      <b>Support Wordmark</b> and unlock all the time saving features
    {:else if $buy_modal_initiator === 'unlimited_previews'}
      <b>Preview unlimited fonts</b> and unlock all the time saving features
    {:else}
      <b>{$_('modals.features.unlock')} {$buy_modal_initiator !== undefined ? feature_name : 'Tagging'}</b> 
      {$_('modals.features.more')}
    {/if}
  {/if}
</h2>

<style>
  h2 {
    font-size: 2.1rem;
    font-family: var(--PensumSans);
  }
  h2 b {
    font-family: var(--PensumSans-Bold);
  }
</style>
